import styled from 'styled-components';

const Table = styled.table`
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.color.border.secondary};
  table-layout: fixed;
`;

export default Table;
